import React from 'react';
// import Select from 'react-select';
import CurrencyInput from 'react-currency-input';
import classnames from 'classnames';

import {
	Button, 
	Modal, 
	ModalHeader, 
	ModalBody, 
	ModalFooter, 
	Input,
	FormText
} from 'reactstrap';

import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';

import { toast } from 'react-toastify';
import windowStop from '../../../../utils/windowStop.js';

export default class ModalFinishWork extends React.Component {
	constructor() {
		super();
		this.inistialState = {
			Alias 				: '',
			Invoice 			: '',
			Amount 				: 0,
			loadingUpload : false,
		}

		this.state = {
			...this.inistialState,
		  	Currency	       	: '',
		  	CURRENCY_MASTER 	: [],
		}

		this.onFinishWorkSuccess = this.onFinishWorkSuccess.bind(this)
		this.onFinishWorkFailed  = this.onFinishWorkFailed.bind(this)			
	}

	generateLabel(MasterReducer) {
		if(MasterReducer === null){
		  return
		}
		let OptionAutoComplete = [];
		for(var i = 0 ; i < MasterReducer.length;i++){
		    OptionAutoComplete.push(
		      <option key={MasterReducer[i].Abbreviations} value={MasterReducer[i].Abbreviations}>{MasterReducer[i].Abbreviations}</option>
		    )      
		}
		return OptionAutoComplete
	}

	initCurrency(master){
		if(master.length > 0){
		  let selectedIndex = 0;
		  for (let i = 0 ; i < master.length ; i++){
		    if (master[i].IsDefault){
		      selectedIndex = i;
		      break;
		    }
		  }
		  this.setState({ Currency:master[selectedIndex].Abbreviations })
		}
	}

	onChangeAmount(event, maskedvalue, floatvalue) {
    	this.setState({ Amount: floatvalue })
  	}

  	onChangeCurrency(event){
  		this.setState({ Currency : event.target.value })
  	}

	onChangeInvoice(e){
		const file = e.target.files[0];
		if(file){
			this.setState({ Invoice : file })
		}else{
			this.setState({ Invoice : '' })
		}
	}

	onFinishWork() {
		if(!FormHelper.ValidateFormFinishWork(this.state)) { return }

		let registerData = new FormData();
		registerData.append('Invoice', this.state.Invoice)
		registerData.append('Currency', this.state.Currency)
		registerData.append('Amount', this.state.Amount)

		if (this.state.Invoice !== ''){ this.setState({loadingDownload: true}) }

		Presenter.FinishWork(
			RequestProperties.FinishWork(
				{
					Alias 	: this.state.Alias,
					Data 	: registerData
				}, 
				this,
				this.onFinishWorkSuccess, 
				this.onFinishWorkFailed
			)
		)
	}

	onFinishWorkSuccess(params, response) {
		this.setState({ loadingDownload : false })
		toast.success("Execute Success")
		this.props.onFinishWorkSuccess(params, response);
	}

	onFinishWorkFailed(response) {
		this.setState({ loadingDownload : false })
		toast.error(response.data.detail)
		this.props.onFinishWorkFailed(response);
	}

	loadMaster() {
		Presenter.ReadAsMaster(
		  RequestProperties.ReadAsMaster('CURRENCY', this, this.ReadMasterSuccess, this.ReadMasterFailed)
		)
	}

	ReadMasterSuccess(params, response) {
	    this.self.setState({ 
	      CURRENCY_MASTER : this.self.generateLabel(response.data)
	    })
	    this.self.initCurrency(response.data);
	}

	ReadMasterFailed(params) {
		console.log(params);
	}

	willUnMount(){
		this.setState(this.inistialState)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ Alias : nextProps.work.alias })
	}

	componentDidMount() {
		this.loadMaster()
	}

	componentWillUnmount() {
		windowStop()
	}

	render() {
		const props = this.props;

		return (
			<Modal isOpen={props.modalFinishWork} toggle={()=>props.closeModal()} onExit = {() => this.willUnMount()}>
				<ModalHeader toggle={()=>props.closeModal()}>Finish Work</ModalHeader>
				<ModalBody>
					<div className={classnames('prepare-preview-report', {'show-f': this.state.loadingDownload})}>
						<h3>Please wait, Uploading Invoice</h3>
						<i className="fa fa-spinner fa-spin"></i>
					</div>
					<div className="row">
						<div className="form-group col-sm-12">
							<label className="required">Amount</label>
							<div className="input-group">
								<div>
										<Input
											style={{
												minWidth : '100px'
											}}
											type="select"
											name="PurchaseCurrency"
											id="PurchaseCurrency"
											value={this.state.Currency}
											onChange={(event)=>this.onChangeCurrency(event)}
											>
												{this.state.CURRENCY_MASTER}
										</Input>
								</div>
									<CurrencyInput 
						className     ="form-control"
						id            ="PurchasePrice"
						value         ={this.state.Amount} 
						onChangeEvent ={this.onChangeAmount.bind(this)}
										/>
							</div>
						</div>
						<div className="form-group col-sm-12">
							<label >Invoice</label>
							<div className = "form-control">
								<Input 
									type="file" 
									name="file" 
									id="invoices" 
									ref="invoiceFile"
									onChange={(event) => this.onChangeInvoice(event)}
										accept="application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
								/>
							</div>
							<FormText color="muted">
								Upload invoices document (optional).
							</FormText>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={()=>props.closeModal()}>Cancel</Button>
					<Button color="primary" onClick={()=>this.onFinishWork()}>Finish</Button>
				</ModalFooter>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Modal/ModalFinishWork.js